export default "__VITE_ASSET__6a5bedeb__"